import { render, staticRenderFns } from "./Waybill.vue?vue&type=template&id=973e4aae&scoped=true"
import script from "./Waybill.vue?vue&type=script&lang=js"
export * from "./Waybill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973e4aae",
  null
  
)

export default component.exports